import e from "react";
import { u as l, D as i } from "./DarkModeProvider-xoZXm3ct.es.js";
import { I as d } from "./Icon-BuIPTPJn.es.js";
import { T as p } from "./Tooltip-B-bmRvX4.es.js";
import { T as f } from "./index-Dd-4N6BE.es.js";
import './Icon3.css';const u = "Icon-module__container___yvffm", _ = {
  container: u
}, M = ({
  name: r,
  label: o,
  color: a,
  altColor: n,
  backgroundColor: s,
  tooltipStyles: c = {},
  iconStyles: m = {}
}) => {
  const t = l();
  return /* @__PURE__ */ e.createElement(
    p.Hover,
    {
      dark: !t,
      trigger: /* @__PURE__ */ e.createElement("div", { style: { backgroundColor: s }, className: _.container }, /* @__PURE__ */ e.createElement(
        d,
        {
          name: r,
          color: a,
          alt_color: n,
          size: "1.25rem",
          style: m
        }
      )),
      placement: "left",
      accessible: !0,
      short: !0
    },
    /* @__PURE__ */ e.createElement(i, { darkMode: !t }, /* @__PURE__ */ e.createElement("div", { style: c }, /* @__PURE__ */ e.createElement(f.Body2, { responsive: !0 }, o)))
  );
};
export {
  M as I
};
